<template>
  <div id="pre-qualify-approved-page" :class="{ mobile: isMobile() }">
    <CloseButton dark sameBgInMobile />
    <div class="header">
      <AssetV3
        class="logo"
        dir="logos"
        name="logo-white.svg"
      />

      <div class="header-content">
        <h1>
          Você está pré-aprovado* para comprar com o Parcelex
        </h1>
      </div>

      <AssetV3
        dir="persons"
        name="happy-guy.svg"
        class="happy-guy"
      />
    </div>
    <div class="container">
      <p class="info">
        Isso quer dizer que você tem um <span class="primary body-bold">
          limite de crédito pré-aprovado de até {{ preApprove.maxCreditValue | moneyFilter }}
        </span> para compras parceladas no boleto em até {{ productSimulation.installments }} vezes,
        <span v-if="productSimulation.downPayment">
          com entrada mínima de {{ productSimulation.downPaymentPercentage }}% e
          juros a partir de {{ productSimulation.interest * 100 | floatFilter }}% a.m.
        </span>
        <span v-else>
          com juros a partir de {{ productSimulation.interest * 100 | floatFilter }}% a.m.
        </span>
      </p>

      <p class="extra-info">
        *O limite informado ainda está sujeito a alteração ou reprovação no momento da compra.
      </p>

      <div class="box-product" v-if="productInfo">
        <h4 v-if="isMobile()">Aproveite para finalizar sua compra:</h4>
        <h4 v-else>
          Aproveite para finalizar a compra do seu produto com condições exclusivas
        </h4>
        <div class="product-container">
          <div class="product">
            <img :src="productInfo.imageUrl" alt="Produto" title="Produto">
            <div class="product-detail">
              <p class="small-semibold gray-600">
                {{ productInfo.name | maxNameFilter }}
              </p>
              <p class="small-regular gray-400">
                {{ productInfo.value | moneyFilter }}
                à vista
              </p>
            </div>
          </div>
          <div class="payment-detail">
            <p class="small-regular gray-600">
              Até {{ productSimulation.installments || maxInstallments }} vezes de
              {{ productSimulation.pmt | moneyFilter }}
              <br/>
              <template v-if="productSimulation.downPayment">
                com entrada de {{ productSimulation.downPaymentPercentage }}%
              </template>
            </p>
            <p class="x-small-regular gray-400">
              Juros a partir de {{ productSimulation.interest * 100 | floatFilter }}% a.m.
            </p>
          </div>
        </div>
        <button @click="handleCheckout">
          Continuar minha compra
        </button>

        <div class="close-simulation">
          <a @click="handleClose">
            Sair da simulação
          </a>
        </div>
      </div>

      <div class="box-parcelex" v-else-if="context === 'parcelex'">
        <h4 class="gray-600">
          Comece a comprar agora mesmo em uma de<br/>nossas lojas parceiras
        </h4>

        <PartnersSlider
          class="partner-slider"
          :partners="partners"
          :gap="8"
          :borderRadius="8"
        />
      </div>

      <button v-else @click="goToMeuParcelex">
        Acessar o Parcelex
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import globals from '@/globals';
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import AssetV3 from '@/components/common/AssetV3.vue';
import CloseButton from '../components/CloseButton.vue';
import PartnersSlider from '../../login/components/PartnersSlider.vue';
import { partners } from '../../../utils/partners';

export default {
  name: 'preQualify-approved',
  mixins: [UtilMixin, StringMixin],
  components: {
    AssetV3,
    CloseButton,
    PartnersSlider,
  },
  data: () => ({
    maxInstallments: globals().maxInstallments,
    partners,
  }),
  computed: {
    ...mapState('preQualify', [
      'context',
      'preApprove',
      'productInfo',
      'productSimulation',
      'hasPreCondition',
    ]),
    ...mapState('auth', [
      'token',
    ]),
    customText() {
      if (this.productInfo) return 'nas lojas parceiras do Parcelex.';
      return `, com entrada mínima de ${this.productSimulation.downPaymentPercentage}%
      e juros a partir de ${this.productSimulation.interest}% a.m.`;
    },
  },
  methods: {
    ...mapActions('preQualify', [
      'close',
      'goToCheckout',
      'emitEvent',
      'updatePreCondition',
    ]),
    handleCheckout() {
      this.goToCheckout();
    },
    handleClose() {
      this.close();
    },
    goToMeuParcelex() {
      this.$router.push(`/portal?authToken=${this.token}`);
    },
  },
  mounted() {
    if (this.hasPreCondition) {
      this.emitEvent({
        type: 'preapproved',
      });
    } else {
      this.emitEvent({
        type: 'approved',
      });
    }
    this.updatePreCondition(true);
  },
};
</script>

<style lang="scss" scoped>
#pre-qualify-approved-page {
  position: relative;
  width: 600px;
  min-height: 580px;
  margin: 0 auto;

  .header {
    box-sizing: border-box;
    height: 300px;

    position: relative;
    padding: 20px 0 20px 36px;
    min-height: 300px;

    background-image: url('https://s3.amazonaws.com/cdn.parcelex.com.br/assets/v3/background/primary-gradient-waves.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;

    .header-content {
      display: flex;

      h1 {
        font-size: 28px;
        color: var(--white);
        margin: 36px 0 90px 0px;
        text-align: left;
        max-width: 60%;
      }
    }

    .happy-guy {
      position: absolute;
      right: 19px;
      bottom: 0;
      width: auto;
      height: 281px;
    }

    h2 {
      margin-top: 36px;
    }
  }

  .container {
    text-align: center;

    .image {
      margin-top: 24px;
    }

    .mt-24 {
      margin-top: 24px;
    }

    h2 {
      @extend .gray-600;
      margin-top: 20px;
    }

    .info {
      @extend .body-regular;
      @extend .gray-700;
      margin-top: 24px;
      text-align: left;
    }

    .extra-info {
      @extend .small-regular;
      @extend .gray-600;
      text-align: left;
      margin-top: 20px;
    }

    .box-product {
      h4 {
        max-width: 368px;
        margin: 24px auto 0 auto;
      }

      button {
        @extend .primary;
        margin: 24px 0px 16px 0px;
      }

      .close-simulation {
        margin-bottom: 36px;

        a {
          @extend .primary;
          cursor: pointer;
        }
      }
    }

    .box-parcelex {
      h4 {
        margin: 24px 0 16px 0;
        font-weight: Bold;
      }

      .stores {
        display: flex;
        justify-content: center;
        gap: 20px;
        margin: 16px 0px 24px 0px;
      }
    }

    .product-container {
      display: flex;
      align-items: center;
      margin-top: 28px;
      justify-content: center;
      background-color: var(--gray-100);

      div {
        width: 100%;
      }

      .product {
        text-align: left;
        display: flex;
        align-items: center;
        padding: 12px;

        .product-detail {
          margin-left: 12px;
        }

        img {
          width: 60px;
        }
      }

      .payment-detail {
        text-align: left;
        border-radius: 4px;
        padding: 12px;

        p:nth-child(2) {
          margin-top: 4px;
        }
      }
    }

    button {
      @extend .primary;
      margin: 24px 0px 36px 0px;
    }
  }

  &.mobile {
    margin: 0;
    width: 100%;
    position: static;

    .header {
      padding: 22px 24px 24px 24px;
      min-height: 222px;
      height: 222px;

      .happy-guy {
        display: none !important;
      }
    }

    .info {
      margin-top: 20px;
    }

    .header-content {
      h1 {
        margin: 0;
        margin-top: 24px;
        max-width: none;
      }
    }

    .container {
      h2 {
        font-size: 22px;
        line-height: 24px;
      }

      h4 {
        margin-top: 20px;
        font-weight: normal;
      }

      .image {
        width: 50%;
      }

      .product-container {
        flex-direction: column;

        .product {
          align-self: baseline;
          width: 90%;
        }

        .payment-detail {
          display: flex;
          flex-direction: column;
          width: 90%;
        }
      }

      .box-parcelex {
        h4 {
          font-weight: Bold;
        }

        .stores {
          img {
            width: 100%;
          }
        }
      }
    }

    button {
      margin: 20px auto;
      width: 100%;
    }
  }
}
</style>
